import { render } from "./cohortreport.vue?vue&type=template&id=ffec5b24"
import script from "./cohortreport.js?vue&type=script&lang=js"
export * from "./cohortreport.js?vue&type=script&lang=js"

import "./cohortreport.vue?vue&type=style&index=0&id=ffec5b24&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__